export function setTitle(title) {
  const suffix = "SpryHub|";
  document.title = `${suffix} ${title}`;
}
